export const tableMixins = {
  data() {
    return {
      isBusy: false,
      showSpinner: false,
      sortDesc: false,
      searchQuery: '',
      statusFilter: '',
      perPage: 10,
      pageSize: 0,
      currentPage: 1,
      perPageOptions: [10, 25, 50, 100],
      totalCount: 0,
      statusOptions: [
        'Active',
        'Inactive',
      ],
      approvalTotalCount: 0,
      approvalPerPage: 10,
      approvalPageSize: 0,
      approvalCurrentPage: 1,
    }
  },
  computed: {
    totalEntries() {
      return this.totalCount
    },
    numberOfPages() {
      return Math.floor((this.totalEntries + this.perPage - 1) / this.perPage)
    },
    from() {
      if (this.totalCount === 0) {
        return 0
      }
      return (this.currentPage * this.perPage) - (this.perPage - 1)
    },
    to() {
      return Math.min(this.from + this.perPage - 1, this.totalEntries)
    },
    approvalTotalEntries() {
      return this.approvalTotalCount
    },
    approvalNumberOfPages() {
      return Math.floor((this.approvalTotalCount + this.approvalPerPage - 1) / this.approvalPerPage)
    },
    approvalFom() {
      if (this.approvalTotalCount === 0) {
        return 0
      }
      return (this.approvalCurrentPage * this.approvalPerPage) - (this.approvalPerPage - 1)
    },
    approvalTo() {
      return Math.min(this.approvalFom + this.approvalPerPage - 1, this.approvalTotalCount)
    },
  },
  methods: {
    variantColor(status) {
      return status === 'Active' ? 'light-success' : 'light-secondary'
    },
    getOverallIndex(index) {
      return (this.currentPage * this.perPage) - this.perPage + index + 1
    },
  },
}

export const _ = null
